import { Field, getIn } from 'formik';
import React, { FunctionComponent } from 'react';

import { CheckboxItemType } from '../../types';
import { IconHandler } from '../../utils';

const CheckboxItem: FunctionComponent<CheckboxItemType> = ({
  formikProps,
  label,
  name,
  title,
  labels = null,
  columnSizes = null,
  tooltipIcon = null,
  tooltip = '',
  checked,
  disabled = false,
  dangerOnSelect = false,
  dangerOnDeselect = false,
  header = false,
  noCheckField = false,
  highlight = false,
  className = '',
  ...props
}) => {
  return (
    <label
      title={title}
      className={`d-flex justify-content-between align-items-center ${
        header ? 'list-group-header' : 'list-group-item'
      } list-group-item-action${getIn(formikProps.values, name) && !header ? ' active' : ''}${
        header
          ? ''
          : dangerOnSelect
            ? ` list-group-item-alt-danger`
            : `${dangerOnDeselect ? 'list-group-item-danger list-group-item-alt-danger' : ''} `
      }${highlight ? ` list-group-item-primary` : ''}`}
    >
      <div className="d-flex justify-content-start align-items-center">
        {!noCheckField && (
          <Field
            className={`me-1 form-check-input ${formikProps.touched?.[name] && formikProps.errors?.[name] && 'text-danger'}`}
            disabled={disabled || formikProps.isSubmitting}
            name={name}
            id={`checkbox-item-${name}`}
            checked={checked ? checked : getIn(formikProps.values, name) || ''}
            type="checkbox"
            {...props}
          />
        )}
      </div>
      {tooltip && tooltipIcon && (
        <div data-bs-toggle="tooltip" title={tooltip!} className={'d-flex'}>
          <IconHandler Icon={tooltipIcon!} size={'1em'} />
        </div>
      )}
      {labels ? (
        <div className="d-flex row justify-content-start align-items-center checkbox-item-content">
          {labels.map((columnLabel: string, index: number) => (
            <div
              className={`col${columnSizes && columnSizes[index] ? '-md-' + columnSizes![index] : ''} my-1 my-md-0`}
              key={`${columnLabel}-${index}`}
            >
              {columnLabel}
            </div>
          ))}
        </div>
      ) : (
        label
      )}
    </label>
  );
};

export default CheckboxItem;
